/**
 * Sanitiza un nombre o apellido de persona eliminando caracteres no permitidos.
 * Preserva: letras Unicode (incluyendo acentos), espacios, apóstrofes (recto y curvo), y guiones.
 * Elimina: dígitos, símbolos especiales, etc.
 *
 * Ejemplos:
 * - "Lucía" → "Lucía"
 * - "Martínez" → "Martínez"
 * - "María-José" → "María-José"
 * - "D'Angelo" → "D'Angelo"
 * - "Juan123$" → "Juan"
 * - "Müller" → "Müller"
 *
 * @param value - El valor a sanitizar
 * @returns El valor sanitizado
 */
export const sanitizePersonName = (value: string): string => {
  if (!value) return "";
  // \p{L} = cualquier letra Unicode (incluyendo acentos)
  // \s = espacios en blanco (preserva espacios que el usuario está escribiendo)
  // ' y ’ = apóstrofe recto y curvo
  // - = guion
  // /u flag = habilita soporte Unicode para \p{L}
  return value.replace(/[^\p{L}\s'’-]/gu, "");
};
